import { render, staticRenderFns } from "./GeneralAgentServiceTrigger.vue?vue&type=template&id=a7bbe1a6&scoped=true"
import script from "./GeneralAgentServiceTrigger.vue?vue&type=script&lang=js"
export * from "./GeneralAgentServiceTrigger.vue?vue&type=script&lang=js"
import style0 from "./GeneralAgentServiceTrigger.vue?vue&type=style&index=0&id=a7bbe1a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bbe1a6",
  null
  
)

export default component.exports